import { controlAnswerKey } from "./regulatoryIdentity"
import type { ICloudRegulatoryControlPoint, IEN1176AnswerMap } from "../types"
import { regulatoryUuid } from "./regulatoryPresentation"
import {
  RegulatoryControlAnswer,
  RegulatoryControlAnswerStatus as Status,
} from "../generated/proto-ts/main"
export const answerStatuses = [
  { label: "Conforme", value: Status.CONFORM, color: "success" },
  { label: "Non conforme", value: Status.NON_CONFORM, color: "error" },
  { label: "Observation", value: Status.OBSERVATION, color: "processing" },
  { label: "À contrôler", value: Status.TO_BE_CHECKED, color: "warning" },
  { label: "Non vérifié", value: Status.NOT_VERIFIED, color: "warning" },
  { label: "N/A", value: Status.NOT_APPLICABLE, color: "default" },
  { label: "Non répondu", value: Status.UNKNOWN_STATUS, color: "default" },
]
export const answerStatus = (value?: Status) =>
  answerStatuses.find((s) => s.value === value) ?? answerStatuses[6]!
export const severityLabels: Record<string, string> = {
  minor: "Mineure",
  major: "Majeure",
  critical: "Critique",
}
export const answerFields = [
  { key: "measurement", label: "Mesure / relevé", max: 1000 },
  { key: "recommendation", label: "Préconisation / action corrective", max: 6000 },
  { key: "immediate_action", label: "Mesure immédiate / information du gestionnaire", max: 6000 },
  { key: "photo_exception", label: "Motif d’absence de photo", max: 6000 },
] as const
export function validateAnswer(answer: RegulatoryControlAnswer): string | undefined {
  if (!answerStatuses.some((s) => s.value === answer.status)) return "Résultat inconnu."
  for (const field of answerFields)
    if (Array.from(answer[field.key] ?? "").length > field.max)
      return `${field.label} : ${field.max} caractères maximum.`
  if (answer.severity && !severityLabels[answer.severity]) return "Gravité interne invalide."
  if (answer.due_date) {
    const value = answer.due_date
    if (
      !/^\d{4}-\d{2}-\d{2}$/.test(value) ||
      value.startsWith("0000") ||
      Number.isNaN(Date.parse(value)) ||
      new Date(value).toISOString().slice(0, 10) !== value
    )
      return "Échéance invalide : utilisez une date réelle au format AAAA-MM-JJ."
  }
}

export function lightReportControls(
  points: ICloudRegulatoryControlPoint[],
  answers: IEN1176AnswerMap,
) {
  return points.filter((point) => {
    const answer = answers[controlAnswerKey(point)]
    return (
      !answer ||
      !regulatoryUuid(answer.control_point_revision_uuid) ||
      ![Status.CONFORM, Status.NOT_APPLICABLE].includes(answer.status)
    )
  })
}
